
import * as XLSX from 'xlsx';
import * as QRCode from 'qrcode';
import { transposeData, splitSpecialElements } from './Utils';

export default {
  data() {
    return {
      typeFile: 0,
      selectedMenu: 'youngmix',
      qrCodeIcon: require('@/assets/qrcode-icon.png'),
      downloadIcon: require('@/assets/download-icon.png'),
      selectedFile: null,
      imageUrl: '',
      qrCodeUrl: '',
      qrCodeUrls: [],
      isDragging: false
    };
  },

  mounted() {
    // Thêm sự kiện listener cho drag & drop và paste
    document.addEventListener('dragover', this.handleDragOver);
    document.addEventListener('drop', this.handleDrop);
    document.addEventListener('paste', this.handlePaste);
  },

  beforeDestroy() {
    // Dọn dẹp sự kiện listener khi component không còn tồn tại
    document.removeEventListener('dragover', this.handleDragOver);
    document.removeEventListener('drop', this.handleDrop);
    document.removeEventListener('paste', this.handlePaste);
  },

  methods: {

    triggerFileSelect() {
      this.$refs.fileInput.click();
    },

    handleFileUpload(event) {
      // Không reset qrCodeUrls ở đây nữa
      if (event.target.files.length === 0) {
        return;
      }

      // Gọi phương thức chung để xử lý file
      this.readFile(event.target.files[0], this.typeFile);
    },

    readFile(file, typeFile) {
      this.qrCodeUrls = []; // Reset danh sách URLs

      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        switch (typeFile) {
          case 0: {
            this.processExcelData(jsonData);
            break;
          }
          case 1: {
            const transposedData = transposeData(jsonData); // Transpose data
            this.processExcelDataAzota(transposedData);
            break;
          }
          case 2: {
            const transposedData = transposeData(jsonData); // Transpose data
            this.processExcelDataSmarttest(transposedData);
            break;
          }
        }

      };
      reader.readAsBinaryString(this.selectedFile);
    },

    processFiles(file) {
      if (file && file.name.endsWith('.xlsx')) {
        this.readFile(file, this.typeFile); // ✅ truyền đúng typeFile
      } else {
        alert("Vui lòng chọn một file Excel (.xlsx)!");
      }
    },

    processExcelData(data) {
      // Lọc ra dòng không hoàn toàn rỗng và loại bỏ cell rỗng trong mỗi dòng
      const filteredData = data
        .slice(1) // Bắt đầu xử lý từ dòng thứ hai
        .filter(row => row.some(cell => cell !== undefined && cell !== ''))
        .map(row => row.filter(cell => cell !== undefined && cell !== ''));

      this.generateQRCodesFromData(filteredData);
    },

    processExcelDataAzota(data) {
      // Lọc ra dòng không hoàn toàn rỗng và loại bỏ cell rỗng trong mỗi dòng
      const filteredData = data
        .slice(1) // Bắt đầu xử lý từ dòng thứ hai
        .filter(row => row.slice(1).some(cell => cell !== undefined && cell !== ''))
        .map(row => row.slice(1).filter(cell => cell !== undefined && cell !== ''));

      console.log(filteredData)
      const transformedData = splitSpecialElements(filteredData);
      console.log(transformedData)

      this.generateQRCodesFromData(transformedData);

    },
    processExcelDataSmarttest(data) {
      // Lọc ra dòng không hoàn toàn rỗng và loại bỏ cell rỗng trong mỗi dòng
      const filteredData = data
        .slice(1) // Bắt đầu xử lý từ dòng thứ hai
        .filter(row => row.some(cell => cell !== undefined && cell !== ''))
        .map(row => row.filter(cell => cell !== undefined && cell !== ''));

      console.log(filteredData)
      const transformedData = splitSpecialElements(filteredData);
      console.log(transformedData)

      this.generateQRCodesFromData(transformedData);

    },

    generateQRCodesFromDataOld(transformedData) {
      const totalNonEmptyCells = transformedData.reduce((total, row) => {
        const nonEmptyCellsInRow = row.filter(cell => cell !== undefined && cell !== '').length;
        return total + nonEmptyCellsInRow;
      }, 0); // Khởi tạo tổng bằng 0

      if (totalNonEmptyCells > 984) { // 984 là giả sử tổng số cell tối đa cho 2 QR code
        alert('Dữ liệu vượt quá giới hạn cho phép của 2 ảnh QR.');
        return;
      } else if (totalNonEmptyCells > 492) { // 492 là giả sử tổng số cell tối đa cho 1 QR code
        console.log('Chia dữ liệu thành 2 phần để tạo 2 ảnh QR.');

        // Chia filteredData thành hai phần
        const halfIndex = Math.ceil(transformedData.length / 2);
        const dataPart1 = transformedData.slice(0, halfIndex);
        const dataPart2 = transformedData.slice(halfIndex);

        // Tạo QR code cho mỗi phần
        this.generateQRCode(dataPart1);
        this.generateQRCode(dataPart2);
      } else {
        // Dữ liệu đủ nhỏ để tạo 1 ảnh QR
        console.log('Tạo 1 ảnh QR với toàn bộ dữ liệu.');
        this.generateQRCode(transformedData);
      }

    },

    generateQRCodesFromData(transformedData) {
      const MAX_CELLS_PER_QR = 492; // Giả sử số cell tối đa cho mỗi ảnh QR
    
      // Tạo một hàm phụ để tính số cell không rỗng trong một tập dữ liệu
      const countNonEmptyCells = (data) => {
        return data.reduce((total, row) => {
          const nonEmptyCellsInRow = row.filter(cell => cell !== undefined && cell !== '').length;
          return total + nonEmptyCellsInRow;
        }, 0);
      };
    
      // Chia dữ liệu thành các phần nhỏ hơn dựa trên số cell không rỗng
      const splitDataIntoParts = (data, maxCellsPerPart) => {
        let parts = [];
        let currentPart = [];
        let currentPartCellCount = 0;
    
        data.forEach(row => {
          const nonEmptyCellsInRow = row.filter(cell => cell !== undefined && cell !== '').length;
    
          if (currentPartCellCount + nonEmptyCellsInRow > maxCellsPerPart) {
            // Nếu thêm hàng hiện tại sẽ vượt quá giới hạn, bắt đầu một phần mới
            parts.push(currentPart);
            currentPart = [];
            currentPartCellCount = 0;
          }
    
          currentPart.push(row);
          currentPartCellCount += nonEmptyCellsInRow;
        });
    
        // Thêm phần cuối cùng nếu không rỗng
        if (currentPart.length > 0) {
          parts.push(currentPart);
        }
    
        return parts;
      };
    
      // Đếm tổng số cell không rỗng trong transformedData
      const totalNonEmptyCells = countNonEmptyCells(transformedData);
    
      if (totalNonEmptyCells > MAX_CELLS_PER_QR * 2) { // Nếu vượt quá giới hạn cho phép của 2 QR code
        console.log('Chia dữ liệu thành nhiều phần để tạo nhiều ảnh QR.');
    
        // Chia dữ liệu thành các phần nhỏ hơn
        const dataParts = splitDataIntoParts(transformedData, MAX_CELLS_PER_QR);
    
        // Tạo QR code cho mỗi phần
        dataParts.forEach((part, index) => {
          console.log(`Tạo QR code cho phần ${index + 1}`);
          this.generateQRCode(part);
        });
      } else if (totalNonEmptyCells > MAX_CELLS_PER_QR) { // Nếu dữ liệu cần chia thành 2 QR code
        console.log('Chia dữ liệu thành 2 phần để tạo 2 ảnh QR.');
    
        // Chia dữ liệu thành hai phần
        const dataParts = splitDataIntoParts(transformedData, MAX_CELLS_PER_QR);
    
        // Tạo QR code cho mỗi phần
        dataParts.forEach((part, index) => {
          console.log(`Tạo QR code cho phần ${index + 1}`);
          this.generateQRCode(part);
        });
      } else {
        // Dữ liệu đủ nhỏ để tạo 1 ảnh QR
        console.log('Tạo 1 ảnh QR với toàn bộ dữ liệu.');
        this.generateQRCode(transformedData);
      }
    },
    

    generateQRCode1(data) {
      const stringData = JSON.stringify(data);
      QRCode.toDataURL(stringData, { errorCorrectionLevel: 'L' }, (err, url) => {
        if (err) throw err;
        this.qrCodeUrls.push(url);
      });
    },

    generateQRCode(data) {
      const stringData = JSON.stringify(data);
      QRCode.toDataURL(stringData, { errorCorrectionLevel: 'L', margin: 1 }, (err, url) => {
        if (err) throw err;
    
        const img = new Image();
        img.src = url;
    
        img.onload = () => {
          const w = img.width;
          const h = img.height;
          const newHeight = h * 1.1;
          const offsetY = h * 0.05;
          const fontSize = h * 0.05;
    
          // Tạo canvas mới
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = newHeight;
          const ctx = canvas.getContext('2d');
    
          // Vẽ QR code gốc lên trên
          ctx.drawImage(img, 0, 0);
    
          // Vẽ dòng chữ
          ctx.fillStyle = '#c49054';
          ctx.font = `${fontSize}px sans-serif`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('Chấm thi QM2025', w / 2, h + offsetY);
    
          const finalUrl = canvas.toDataURL();
          this.qrCodeUrls.push(finalUrl);
        };
      });
    },
    
    downloadQRCode(index) {
      const a = document.createElement('a');
      a.href = this.qrCodeUrls[index];
      a.download = `QRCode-${index + 1}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    downloadExcelFileOld() {
      switch (this.typeFile) {
        case 0: {
          window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;
        }
        case 1: {
          window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;
        }
        case 2: {
          window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;

        }
      }
    },

    downloadExcelFile() {
      let urlXLSX = "";
      switch (this.typeFile) {
        case 0:
          urlXLSX = "/dapanQM2025.xlsx";
          break;
        case 1:
          urlXLSX = "/dapanAzota2025.xlsx";
          break;
        case 2:
          urlXLSX = "/dapanSmarttest2025.xlsx";
          break;
      }

      const a = document.createElement('a');
      a.href = urlXLSX;
      a.download = urlXLSX.split('/').pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    navigateTo(routeName) {
      this.qrCodeUrls = []; // Reset danh sách URLs
      switch (routeName) {
        case 'youngmix':
          this.selectedMenu = routeName;
          this.typeFile = 0;
          console.log(this.typeFile)
          // window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;

        case 'azota':
          this.selectedMenu = routeName;
          this.typeFile = 1;
          console.log(this.typeFile)
          // window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;

        case 'smarttest':
          this.selectedMenu = routeName;
          this.typeFile = 2;
          console.log(this.typeFile)
          // window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;

        case 'mcmix':
          window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;

        case 'intest':
          window.open("https://docs.google.com/spreadsheets/d/1LEJ4yZ_A6amoS5eWbdkIpCCmeOLC2gGN", '_blank');
          break;

      }
    },

    handleDragOver(event) {
      event.preventDefault(); // Ngăn chặn hành động mặc định
      this.isDragging = true;
    },

    handleDragLeave() {
      this.isDragging = false;
    },

    handleDrop(event) {
      this.isDragging = false;
      console.log("File dropped!");
      event.preventDefault();
      event.stopPropagation(); // Ngăn chặn sự kiện lan ra ngoài
      const files = event.dataTransfer.files;
      if (files.length) {
        this.processFiles(files[0]);
      }
    },

    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      for (let item of items) {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          this.processFiles(file);
          break;
        }
      }
    },

  }
};

